<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="考站名称:">
          <el-input v-model="listQuery['filter[name]']" clearable placeholder="考站名称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
          <el-button type="success" size="medium" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="id" label="序号">
      </el-table-column>
      <el-table-column prop="name" label="考站名称" >
      </el-table-column>
      <el-table-column   label="考站类型" >
        <template slot-scope="scope">
          {{options[scope.row.type]}}
        </template>
      </el-table-column>
      <el-table-column  label="考试项目" >
        <template slot-scope="scope">
          {{scope.row.subject.name}}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="warning" size="small"  @click="handleEdit(scope)">编辑</el-button>
          <el-button type="danger" size="small" @click="handleDelete(scope)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- v-if="pageform.total>pageform.pageSize" -->

    <div style="text-align: right;margin-top:20px">

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.per_page" @pagination="getData"/>

    </div>
    <el-dialog :visible.sync="dialogVisible" :title="dialogType==='edit'?'编辑考站':'新增考站'">
      <el-form :model="station" label-width="80px" label-position="left">
        <el-form-item label="名称" prop="name" required>
          <el-input v-model="station.name" placeholder="输入名称"/>
        </el-form-item>
        <el-form-item label="考站类型" >
          <el-select v-model="station.type" placeholder="请选择">
            <el-option
              v-for="(item,key) in options"
              :key="key"
              :label="item"
              :value="key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试项目" >
          <el-select v-model="station.subject_id" placeholder="请选择">
            <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属考场" >
          <el-select v-model="station.room_id" placeholder="请选择">
            <el-option
              v-for="item in roomList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="关联摄像机" >-->
<!--          <el-select v-model="station.room_id" placeholder="请选择">-->
<!--            <el-option-->
<!--              v-for="item in roomList"-->
<!--              :key="item.id"-->
<!--              :label="item.name"-->
<!--              :value="item.id">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
      </el-form>
      <div style="text-align:right;">
        <el-button type="danger" @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmSave">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
    import Pagination from '../../components/Pagination'
    export default {
        components: { Pagination },
  props: {

  },
  data() {
    return {
        options: {
            1:'技能考站',
            2:'理论考站',
        },
        station:{
            room:{}
        },
        roomList:[],
        subjectList:[],
        total:0,
        dialogType:'new',
        dialogVisible:false,
        listQuery: {
            page: 1,
            per_page:20,
            include:'subject'
        },
      tableData: []
    };
  },
  computed: {

  },
  created() {
    this.getData();
    this.getRoomList();
    this.getSubjectList();
  },
  methods: {
      getRoomList()
      {
        this.$http.getRooms({page_size:100000}).then(res=>{
            this.roomList=res.data;
        })
      },
      getSubjectList()
      {
        this.$http.getSubjects({page_size:100000}).then(res=>{
            this.subjectList=res.data;
        })
      },
    search() {
      this.listQuery.page = 1;
      this.getData()
    },
    // 获取全部的课程列表
    getData() {
      this.$http.getStations(this.listQuery)
        .then(res => {
          this.tableData = res.data;
            this.total = res.meta.total;
        })
        .catch(err => {
          console.log(err);
        })
    },
      handleAdd() {
          this.station = {};
          this.dialogType = 'new';
          this.dialogVisible = true
      },
      handleEdit(scope) {
          this.dialogType = 'edit';
          this.dialogVisible = true;
          this.$http.getStation(scope.row.id,{include:'subject,room'}).then(res=>{
              this.station =res.data
              this.station.room_id=res.data.room[0].id;
          })
      },
      confirmSave(){
          const isEdit = this.dialogType === 'edit'
          if (isEdit) {
              this.$http.updateStation(this.station.id, this.station).then(res => {
                  this.dialogVisible = false
                  this.$notify({
                      title: 'Success',
                      message: '操作成功！',
                      type: 'success'
                  });
                  this.getData()
              })
          } else {
              this.$http.addStation(this.station).then(res => {
                  this.dialogVisible = false
                  this.$notify({
                      title: 'Success',
                      message: '操作成功！',
                      type: 'success'
                  })
                  this.getData()
              })
          }
      },
      handleDelete({$index, row}) {
          this.$confirm('确定要删除此条吗?', '警告', {
              confirmButtonText: '删除',
              cancelButtonText: '取消',
              type: 'warning'
          })
              .then(() => {
                  this.$http.deleteStation(row.id).then(res => {
                      this.tableData.splice($index, 1)
                      this.$message({
                          type: 'success',
                          message: '删除成功!'
                      })
                  });

              })
              .catch(err => {
                  console.error(err)
              })
      },
  },
};
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/page/resourceManage/stations.vue